module.exports = __webpack_public_path__ + "img/selma-dallas.009afbdd.jpg";